// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-found-container {
	width: 500px;
	height: 400px;
	text-align: center;
	padding: 20px;
	background: #fff;
	border-radius: 15px;
	box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
	animation: float 3s infinite ease-in-out;
}

.not-found-title {
	font-size: 6rem;
	color: #ff6f61;
	margin: 0;
}

.not-found-message {
	font-size: 1.8rem;
	color: #555;
	margin: 10px 0 20px;
}

.not-found-link {
	display: block;
	margin: 50px auto 0 auto;
	width: 200px;
	text-decoration: none;
	color: #fff;
	background: #007bff;
	padding: 10px 20px;
	font-size: 1.2rem;
	border-radius: 5px;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
	transition: background 0.3s ease;
}

.not-found-link:hover {
	background: #0056b3;
}

@keyframes float {
	0%,
	100% {
		transform: translateY(0);
	}
	50% {
		transform: translateY(-10px);
	}
}
`, "",{"version":3,"sources":["webpack://./src/pages/NotFound/NotFound.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,aAAa;CACb,gBAAgB;CAChB,mBAAmB;CACnB,yCAAyC;CACzC,wCAAwC;AACzC;;AAEA;CACC,eAAe;CACf,cAAc;CACd,SAAS;AACV;;AAEA;CACC,iBAAiB;CACjB,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,wBAAwB;CACxB,YAAY;CACZ,qBAAqB;CACrB,WAAW;CACX,mBAAmB;CACnB,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,wCAAwC;CACxC,gCAAgC;AACjC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC;;EAEC,wBAAwB;CACzB;CACA;EACC,4BAA4B;CAC7B;AACD","sourcesContent":[".not-found-container {\n\twidth: 500px;\n\theight: 400px;\n\ttext-align: center;\n\tpadding: 20px;\n\tbackground: #fff;\n\tborder-radius: 15px;\n\tbox-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);\n\tanimation: float 3s infinite ease-in-out;\n}\n\n.not-found-title {\n\tfont-size: 6rem;\n\tcolor: #ff6f61;\n\tmargin: 0;\n}\n\n.not-found-message {\n\tfont-size: 1.8rem;\n\tcolor: #555;\n\tmargin: 10px 0 20px;\n}\n\n.not-found-link {\n\tdisplay: block;\n\tmargin: 50px auto 0 auto;\n\twidth: 200px;\n\ttext-decoration: none;\n\tcolor: #fff;\n\tbackground: #007bff;\n\tpadding: 10px 20px;\n\tfont-size: 1.2rem;\n\tborder-radius: 5px;\n\tbox-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n\ttransition: background 0.3s ease;\n}\n\n.not-found-link:hover {\n\tbackground: #0056b3;\n}\n\n@keyframes float {\n\t0%,\n\t100% {\n\t\ttransform: translateY(0);\n\t}\n\t50% {\n\t\ttransform: translateY(-10px);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
